import(/* webpackMode: "eager" */ "/vercel/path0/apps/outlook-addin/src/app/layout.tsx");
